import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {MisService} from './mis.service';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {Router} from '@angular/router';
import {PaginationInstance} from 'ngx-pagination';
import {DaterangepickerConfig} from 'ng2-daterangepicker';
import {DashboardService} from '../configuration/dashboard/dashboard.service';
import {Aarogyam} from '../shared/my-constants';
import { CONSTMEDIFYHUB } from '../shared/my-constants';

@Component({
    selector: 'app-login',
    templateUrl: './mis.component.html',
    styleUrls: ['./mis.component.css']
})
export class MisComponent implements OnInit {
    todayDate: any;
    appointmentList: Array<any> = [];
    registrationList: Array<any> = [];
    visitList: Array<any> = [];
    billList: Array<any> = [];
    collectionsummery: any = {};
    radiotestList: Array<any> = [];
    pharmacyBillList: Array<any> = [];
    pharmacyRetrunList: Array<any> = [];
    arraysize: any;
    labTestList: Array<any> = [];
    misViewtype: string = 'defaultview';
    search_query: any = {};
    printList: Array<any> = [];
    public strtdate: any = null;
    public enddate: any = null;
    totalamunt: any = 0.00;
    tariffList: Array<any> = [];
    servicelistbytarifflist: Array<any> = [];
    // user Permission
    userAccess: Array<any> = [];
    currentUseraction: Array<any> = [];
    currentUserdetails: any;
    uaEmergencyMISReports: boolean;
    uaServiceMISReports: boolean;
    uaPharmacyMISReports: boolean;
    uaDocShareMISReports: boolean;
    uaManagementMISReports: boolean;
    uaInventoryMISReports: boolean;
    uaInvestigationMISReports: boolean;
    uaBillingMISReports: boolean;
    uaIPDMISReports: boolean;
    uaOPDDoctorMISReports: boolean;
    uaMGTReports: boolean;
    uaOPDFrontDeskMISReports: boolean;
    uaAdministrativeMISReports: boolean;
    uaBIMISReports: boolean;
    uaTallyMISReports: boolean;
    aarogyam: Boolean = Aarogyam;
    CONSTMEDIFYHUB: Boolean = CONSTMEDIFYHUB;
    public config: PaginationInstance = {
        id: 'advanced',
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: 1
    };

    constructor(private fb: FormBuilder, private misService: MisService, private router: Router, public toastr: ToastsManager, vcr: ViewContainerRef,
                private daterangepickerOptions: DaterangepickerConfig,
                private dashboardService: DashboardService) {
        this.toastr.setRootViewContainerRef(vcr);
        this.daterangepickerOptions.settings = {
            locale: {format: 'YYYY-MM-DD'},
            alwaysShowCalendars: false,
            singleDatePicker: true,
            showDropdowns: true,
            autoUpdateInput: false
        };
        this.todayDate = Date.now();
    }

    ngOnInit() {
        this.onViewSelect('defaultview');
        this.search_query.today = false;
        this.search_query.strtdate = '';
        this.search_query.enddate = '';
        this.search_query.print = false;
        this.getTariffList();
        this.currentUserdetails = JSON.parse(sessionStorage.getItem('userdetail'));
        this.userAccess = JSON.parse(sessionStorage.getItem('useraction'));
        this.currentUseraction = JSON.parse(sessionStorage.getItem('useraction'));
        this.userCompAccess();
        // this.loadUserSubModule();
    }

    onViewSelect(value: any) {
        switch (value) {
            case 'appointmentlist':
                this.misViewtype = 'appointmentlist';
                this.search_query.today = false;
                this.search_query.strtdate = '';
                this.search_query.enddate = '';
                this.search_query.print = false;
                this.getAppointmentList(1);
                break;
            case 'registrationlist':
                this.search_query.today = false;
                this.search_query.strtdate = '';
                this.search_query.enddate = '';
                this.search_query.print = false;
                this.misViewtype = 'registrationlist';
                this.getRegistrationList(1);
                break;
            case 'visitlist':
                this.search_query.today = false;
                this.search_query.strtdate = '';
                this.search_query.enddate = '';
                this.search_query.print = false;
                this.misViewtype = 'visitlist';
                this.getVisitList(1);
                break;
            case 'collectionsummery':
                this.search_query.today = false;
                this.search_query.strtdate = '';
                this.search_query.print = false;
                this.search_query.enddate = '';
                this.misViewtype = 'collectionsummery';
                this.getCollectionsummery(1);
                break;
            case 'collectiondetails':
                this.search_query.today = false;
                this.search_query.strtdate = '';
                this.search_query.enddate = '';
                this.search_query.print = false;
                this.misViewtype = 'collectiondetails';
                this.getCollectiondetails(1);
                break;
            case 'billlist':
                this.misViewtype = 'billlist';
                this.getBilllist(1);
                break;
            case 'pharmacysale':
                this.search_query.today = false;
                this.search_query.print = false;
                this.search_query.print = false;
                this.search_query.strtdate = '';
                this.search_query.enddate = '';
                this.misViewtype = 'pharmacysale';
                this.getPharmacysale(1);
                break;
            case 'pharmacybilllist':
                this.search_query.today = false;
                this.search_query.print = false;
                this.search_query.strtdate = '';
                this.search_query.enddate = '';
                this.misViewtype = 'pharmacybilllist';
                this.getPharmacybilllist(1);
                break;
            case 'pharmacyreturn':
                this.search_query.print = false;
                this.search_query.today = false;
                this.search_query.strtdate = '';
                this.search_query.enddate = '';
                this.misViewtype = 'pharmacyreturn';
                this.getPharmacyreturn(1);
                break;
            case 'labtestcount':
                this.search_query.print = false;
                this.search_query.today = false;
                this.search_query.strtdate = '';
                this.search_query.enddate = '';
                this.misViewtype = 'labtestcount';
                this.getLabtestcount(1);
                break;
            case 'billlist':
                this.search_query.print = false;
                this.search_query.today = false;
                this.search_query.strtdate = '';
                this.search_query.enddate = '';
                this.misViewtype = 'billlist';
                this.getBilllist(1);
                break;
            case 'radiologytestcount':
                this.search_query.print = false;
                this.search_query.today = false;
                this.search_query.strtdate = '';
                this.search_query.radioreporttype = '';
                this.search_query.enddate = '';
                this.misViewtype = 'radiologytestcount';
                this.getRadiologytestcount(1);
                break;
            case 'servicebytariff':
                this.search_query.print = false;
                this.search_query.today = false;
                this.search_query.strtdate = '';
                this.search_query.radioreporttype = '';
                this.search_query.enddate = '';
                this.misViewtype = 'servicebytariff';
                this.getServicebytariff(1);
                break;
            default:
                this.misViewtype = 'defaultview';
                break;
        }
    }

    refresh() {
        // console.log("refresh view type");
        // console.log(this.misViewtype);
        this.search_query.today = false;
        this.search_query.strtdate = '';
        this.search_query.enddate = '';
        this.search_query.search = '';
        this.search_query.tariff = 0;
        this.onViewSelect(this.misViewtype);
    }

    getAppointmentList(page: number) {
        this.search_query.page = page;
        this.search_query.size = this.config.itemsPerPage;
        this.misService.getAppointmentList(this.search_query)
            .then(resp => {
                this.appointmentList = resp.content;
                this.config.currentPage = page;
                this.config.totalItems = resp.totalElements;
                // console.log("Appointment");
                // console.log(this.appointmentList);
            });
    }

    getRegistrationList(page: number) {
        this.search_query.page = page;
        this.search_query.size = this.config.itemsPerPage;
        this.misService.getRegistrationList(this.search_query)
            .then(resp => {
                this.registrationList = resp.content;
                this.config.currentPage = page;
                this.config.totalItems = resp.totalElements;
                // console.log("Registration");
                // console.log(this.registrationList);
            });
    }

    getVisitList(page: number) {
        this.search_query.page = page;
        this.search_query.size = this.config.itemsPerPage;
        this.misService.getVisitList(this.search_query)
            .then(resp => {
                this.visitList = resp.content;
                this.config.currentPage = page;
                this.config.totalItems = resp.totalElements;
                // console.log("visitList");
                // console.log(this.visitList);
            });
    }

    getBilllist(page: number) {
        this.search_query.page = page;
        this.search_query.size = this.config.itemsPerPage;
        this.misService.getBilllist(this.search_query)
            .then(resp => {
                this.billList = resp.content;
                this.config.currentPage = page;
                this.config.totalItems = resp.totalElements;
                // console.log("billList");
                // console.log(this.billList);
            });
    }

    getCollectionsummery(page: number) {
        // console.log("search query");
        // console.log(this.search_query);
        this.misService.getCollectionsummery(this.search_query)
            .then(resp => {
                this.collectionsummery = resp;
                // console.log("collectionsummery");
                // console.log(this.collectionsummery);
                this.totalamunt = this.collectionsummery.opdTotalCollection + this.collectionsummery.ipdTotalCollection;
            });
    }

    getCollectiondetails(page: number) {
    }

    getPharmacysale(page: number) {
    }

    getPharmacyreturn(page: number) {
        this.search_query.page = page;
        this.search_query.size = this.config.itemsPerPage;
        this.misService.getPharmacyreturnlist(this.search_query)
            .then(resp => {
                this.pharmacyRetrunList = resp.content;
                this.config.currentPage = page;
                this.config.totalItems = resp.totalElements;
                // console.log("pharmacyRetrunList");
                // console.log(this.pharmacyRetrunList);
            });
    }

    getLabtestcount(page: number) {
        this.search_query.page = page;
        this.search_query.size = this.config.itemsPerPage;
        this.misService.getLablist(this.search_query)
            .then(resp => {
                this.labTestList = resp.content;
                this.config.currentPage = page;
                this.config.totalItems = resp.totalElements;
                // console.log("labTestList");
                // console.log(this.labTestList);
            });
    }

    getLabperformancereport(page: number) {
    }

//  getRadiologyperformancereport(page: number)
//  {
//    this.misService.getRadiologyperformancelist(page, this.config.itemsPerPage, '', '', '')
//      .then(resp => {
//        this.radioperformanceList  = resp.content;
//        this.config.currentPage = page;
//        this.config.totalItems = resp.totalElements;
//        // console.log("radioperformanceList");
//        // console.log(this.radioperformanceList);
//      });
//  }
    getPharmacybilllist(page: number) {
        this.search_query.page = page;
        this.search_query.size = this.config.itemsPerPage;
        this.misService.getPharmacybilllist(this.search_query)
            .then(resp => {
                this.pharmacyBillList = resp.content;
                this.config.currentPage = page;
                this.config.totalItems = resp.totalElements;
                // console.log("pharmacyBillList");
                // console.log(this.pharmacyBillList);
            });
    }

// radiology list
    getRadiologytestcount(page: number) {
        this.search_query.page = page;
        this.search_query.size = this.config.itemsPerPage;
        this.misService.getRadiologytestlist(this.search_query)
            .then(resp => {
                this.radiotestList = resp.content;
                this.config.currentPage = page;
                this.config.totalItems = resp.totalElements;
                // console.log("radiotestList");
                // console.log(this.radiotestList);
            });
    }

    getPrintList() {
        this.search_query.print = true;
        this.misService.getAppointmentList(this.search_query)
            .then(resp => {
                this.printList = resp;
                // console.log("printList");
                // console.log(this.printList);
                // console.log(this.printList.length);
                this.search_query.print = false;
            });
    }

    getPrintAppointmentList() {
        this.misService.getAppointmentList(this.search_query)
            .then(resp => {
                this.printList = resp;
                this.config.totalItems = resp.length;
                // console.log("printList");
                // console.log(this.printList);
                if (this.printList) {
                    setTimeout(() => this.printMisList('printAppoinmentSection'), 1000);
                }
            });
    }

    getPrintRegistrationList() {
        this.misService.getRegistrationList(this.search_query)
            .then(resp => {
                this.printList = resp;
                this.config.totalItems = resp.length;
                // console.log("printList");
                // console.log(this.printList);
                if (this.printList) {
                    setTimeout(() => this.printMisList('printRegistrationSection'), 1000);
                }
            });
    }

    getPrintVisitList() {
        this.misService.getVisitList(this.search_query)
            .then(resp => {
                this.printList = resp;
                this.config.totalItems = resp.length;
                // console.log("printList");
                // console.log(this.printList);
                if (this.printList) {
                    setTimeout(() => this.printMisList('printVisitSection'), 1000);
                }
            });
    }

    getPrintBilllist() {
        this.misService.getBilllist(this.search_query)
            .then(resp => {
                this.printList = resp;
                this.config.totalItems = resp.length;
                // console.log("printList");
                // console.log(this.printList);
                if (this.printList) {
                    setTimeout(() => this.printMisList('printBillSection'), 1000);
                }
            });
    }

    getPrintPharmacybilllist() {
        this.misService.getPharmacybilllist(this.search_query)
            .then(resp => {
                this.printList = resp;
                this.config.totalItems = resp.length;
                // console.log("printList");
                // console.log(this.printList);
                if (this.printList) {
                    setTimeout(() => this.printMisList('printPharmacyBillListSection'), 1000);
                }
            });
    }

    getPrintPharmacyreturn() {
        this.misService.getPharmacyreturnlist(this.search_query)
            .then(resp => {
                this.printList = resp;
                this.config.totalItems = resp.length;
                // console.log("printList");
                // console.log(this.printList);
                if (this.printList) {
                    setTimeout(() => this.printMisList('printPharmacyReturnListSection'), 1000);
                }
            });
    }

    getPrintLabtestcount() {
        this.misService.getLablist(this.search_query)
            .then(resp => {
                this.printList = resp;
                this.config.totalItems = resp.length;
                // console.log("printList");
                // console.log(this.printList);
                if (this.printList) {
                    setTimeout(() => this.printMisList('printLabListSection'), 1000);
                }
            });
    }

    getPrintRadiologytestcount() {
        this.misService.getRadiologytestlist(this.search_query)
            .then(resp => {
                this.printList = resp;
                this.config.totalItems = resp.length;
                // console.log("printList");
                // console.log(this.printList);
                if (this.printList) {
                    setTimeout(() => this.printMisList('printRadiologyListSection'), 1000);
                }
            });
    }

    getPrintServicebytariff() {
        this.misService.getServicebytariff(this.search_query)
            .then(resp => {
                this.printList = resp;
                this.config.totalItems = resp.length;
                // console.log("printList");
                // console.log(this.printList);
                if (this.printList) {
                    setTimeout(() => this.printMisList('printservicedetails'), 1000);
                }
            });
    }

    getServicebytariff(page: any) {
        this.search_query.page = page;
        this.search_query.size = this.config.itemsPerPage;
        this.misService.getServicebytariff(this.search_query)
            .then(resp => {
                this.servicelistbytarifflist = resp.content;
                this.config.currentPage = page;
                this.config.totalItems = resp.totalElements;
                // console.log("servicelistbytarifflist");
                // console.log(resp);
            });
    }

// radiology dropdown search
    displayByRadiologyReportType(radioreporttype, page) {
        //  this.search_query = '';
        this.search_query.radioreporttype = radioreporttype;
        this.getRadiologytestcount(page);
    }

// pagination methods
    onRecordCountChange(records: number) {
        this.config.itemsPerPage = records;
        if (this.misViewtype == 'appointmentlist') {
            this.getAppointmentList(this.config.currentPage);
        }
        else if (this.misViewtype == 'registrationlist') {
            this.getRegistrationList(this.config.currentPage);
        }
        else if (this.misViewtype == 'visitlist') {
            this.getVisitList(this.config.currentPage);
        }
        else if (this.misViewtype == 'collectionsummery') {
            this.getCollectionsummery(this.config.currentPage);
        }
        else if (this.misViewtype == 'collectiondetails') {
            this.getCollectiondetails(this.config.currentPage);
        }
        else if (this.misViewtype == 'billList') {
            this.getBilllist(this.config.currentPage);
        }
        else if (this.misViewtype == 'pharmacysale') {
            this.getPharmacysale(this.config.currentPage);
        }
        else if (this.misViewtype == 'pharmacybilllist') {
            this.getPharmacybilllist(this.config.currentPage);
        }
        else if (this.misViewtype == 'pharmacyreturn') {
            this.getPharmacyreturn(this.config.currentPage);
        }
        else if (this.misViewtype == 'labtestcount') {
            this.getLabtestcount(this.config.currentPage);
        }
        else if (this.misViewtype == 'labperformancereport') {
            this.getLabperformancereport(this.config.currentPage);
        }
        else if (this.misViewtype == 'radiologytestcount') {
            this.getRadiologytestcount(this.config.currentPage);
        }
        else if (this.misViewtype == 'servicedetails') {
            this.getServicebytariff(this.config.currentPage);
        }
    }

// all search
    allSearch(search, page) {
        // this.search_query = '';
        this.search_query.search = search;
        this.search_query.page = page;
        this.search_query.size = this.config.itemsPerPage;
        this.search_query.size = this.config.itemsPerPage;
        if (this.misViewtype == 'appointmentlist') {
            this.getAppointmentList(page);
        }
        else if (this.misViewtype == 'registrationlist') {
            this.getRegistrationList(page);
        }
        else if (this.misViewtype == 'visitlist') {
            this.getVisitList(page);
        }
        else if (this.misViewtype == 'collectionsummery') {
            this.getCollectionsummery(page);
        }
        else if (this.misViewtype == 'collectiondetails') {
            this.getCollectiondetails(page);
        }
        else if (this.misViewtype == 'billlist') {
            this.getBilllist(page);
        }
        else if (this.misViewtype == 'pharmacysale') {
            this.getPharmacysale(page);
        }
        else if (this.misViewtype == 'pharmacybilllist') {
            this.getPharmacybilllist(page);
        }
        else if (this.misViewtype == 'pharmacyreturn') {
            this.getPharmacyreturn(page);
        }
        else if (this.misViewtype == 'labtestcount') {
            this.getLabtestcount(page);
        }
        else if (this.misViewtype == 'labperformancereport') {
            this.getLabperformancereport(page);
        }
        else if (this.misViewtype == 'radiologytestcount') {
            this.getRadiologytestcount(page);
        }
        else if (this.misViewtype == 'servicedetails') {
            this.getServicebytariff(page);
        }
    }

// today search
    todaySearch($event: any, page: any) {
        // console.log($event.target.checked);
        this.search_query.today = $event.target.checked;
        this.search_query.page = page;
        this.search_query.size = this.config.itemsPerPage;
        if (this.misViewtype == 'appointmentlist') {
            this.getAppointmentList(page);
        }
        else if (this.misViewtype == 'registrationlist') {
            this.getRegistrationList(page);
        }
        else if (this.misViewtype == 'visitlist') {
            this.getVisitList(page);
        }
        else if (this.misViewtype == 'collectionsummery') {
            this.getCollectionsummery(page);
        }
        else if (this.misViewtype == 'collectiondetails') {
            this.getCollectiondetails(page);
        }
        else if (this.misViewtype == 'billlist') {
            this.getBilllist(page);
        }
        else if (this.misViewtype == 'pharmacysale') {
            this.getPharmacysale(page);
        }
        else if (this.misViewtype == 'pharmacybilllist') {
            this.getPharmacybilllist(page);
        }
        else if (this.misViewtype == 'pharmacyreturn') {
            this.getPharmacyreturn(page);
        }
        else if (this.misViewtype == 'labtestcount') {
            this.getLabtestcount(page);
        }
        else if (this.misViewtype == 'labperformancereport') {
            this.getLabperformancereport(page);
        }
        else if (this.misViewtype == 'radiologytestcount') {
            this.getRadiologytestcount(page);
        }
        else if (this.misViewtype == 'servicedetails') {
            this.getServicebytariff(page);
        }
    }

    print(printSection: any): void {
        let printContents, popupWin;
        // printContents = document.getElementById('printSection').innerHTML;
        printContents = document.getElementById(printSection).innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
          <html>
              
                  <title>Print tab</title>
                  
                  <!-- Latest compiled and minified CSS -->
                  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">

                  <!-- jQuery library -->
                  <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>

                  <!-- Latest compiled JavaScript -->
                  <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script> 
                  
              </head>
              <body onload="window.print();window.close()">${printContents}
              </body>
          </html>`
        );
        popupWin.document.close();
    }

    getList() {
        this.search_query.print = true;
        if (this.misViewtype == 'appointmentlist') {
            this.getPrintAppointmentList();
        }
        else if (this.misViewtype == 'registrationlist') {
            this.getPrintRegistrationList();
        }
        else if (this.misViewtype == 'visitlist') {
            this.getPrintVisitList();
        }
        else if (this.misViewtype == 'billlist') {
            this.getPrintBilllist();
        }
        else if (this.misViewtype == 'pharmacybilllist') {
            this.getPrintPharmacybilllist();
        }
        else if (this.misViewtype == 'pharmacyreturn') {
            this.getPrintPharmacyreturn();
        }
        else if (this.misViewtype == 'labtestcount') {
            this.getPrintLabtestcount();
        }
        else if (this.misViewtype == 'radiologytestcount') {
            // console.log("report type");
            // console.log(this.search_query.radioreporttype);
            this.getPrintRadiologytestcount();
        }
        else if (this.misViewtype == 'servicebytariff') {
            this.getPrintServicebytariff();
        }
    }

    printMisList(print: any) {
        let printContents, popupWin;
        printContents = document.getElementById(print).innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
          <html>              
                  <title>Print tab</title>
                  
                  <style>
                    .widget-footer{
                    display: none;
                    }
                  </style>
                  
                  <!-- Latest compiled and minified CSS -->
                  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">

                  <!-- jQuery library -->
                  <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>

                  <!-- Latest compiled JavaScript -->
                  <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script> 
                  
              </head>
              <body onload="window.print();window.close()">${printContents}
              </body>
          </html>`
        );
        popupWin.document.close();
        this.search_query.print = false;
        this.printList = [];
    }

    getSelectedTariff(id: any) {
        this.search_query.tariff = id;
        // console.log("before call");
        this.getServicebytariff(1);
    }

    getTariffList() {
        this.dashboardService.getTariffList()
            .then(resp => {
                this.tariffList = resp;
                // console.log("getTariffList");
                // console.log(this.tariffList);
            });
    }

    userCompAccess() {
        for (let i = 0; i < this.userAccess.length; i++) {
            if (this.userAccess[i].aurActionModuleName == 'Emergency MIS Reports') {
                this.uaEmergencyMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Service MIS Reports') {
                this.uaServiceMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Pharmacy MIS Reports') {
                this.uaPharmacyMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Doctor Share MIS Reports') {
                this.uaDocShareMISReports= true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Inventory MIS Reports') {
                this.uaInventoryMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Investigation MIS Reports') {
                this.uaInvestigationMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Billing MIS Reports') {
                this.uaBillingMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'IPD MIS Reports') {
                this.uaIPDMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'OPD (Doctor) MIS Reports') {
                this.uaOPDDoctorMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'MGT MIS Reports') {
                this.uaMGTReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'OPD (Front Desk) MIS Reports') {
                this.uaOPDFrontDeskMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Administrative MIS Reports') {
                this.uaAdministrativeMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'BI MIS Reports') {
                this.uaBIMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Tally MIS Reports') {
                this.uaTallyMISReports = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Management MIS Reports') {
                this.uaManagementMISReports = true;
            }
        }
    }

    // select start date search
    private selectedStartDate(value: any) {
        this.strtdate = value.start.format('YYYY-MM-DD');
        this.search_query.strtdate = this.strtdate;
        // console.log(this.search_query.strtdate);
    }

    // select end date to search
    private selectedEndDate(value: any) {
        this.enddate = value.start.format('YYYY-MM-DD');
        this.search_query.enddate = this.enddate;
        if (this.misViewtype == 'appointmentlist') {
            this.getAppointmentList(1);
        }
        else if (this.misViewtype == 'registrationlist') {
            this.getRegistrationList(1);
        }
        else if (this.misViewtype == 'visitlist') {
            this.getVisitList(1);
        }
        else if (this.misViewtype == 'collectionsummery') {
            this.getCollectionsummery(1);
        }
        else if (this.misViewtype == 'collectiondetails') {
            this.getCollectiondetails(1);
        }
        else if (this.misViewtype == 'billlist') {
            this.getBilllist(1);
        }
        else if (this.misViewtype == 'pharmacysale') {
            this.getPharmacysale(1);
        }
        else if (this.misViewtype == 'pharmacybilllist') {
            this.getPharmacybilllist(1);
        }
        else if (this.misViewtype == 'pharmacyreturn') {
            this.getPharmacyreturn(1);
        }
        else if (this.misViewtype == 'labtestcount') {
            this.getLabtestcount(1);
        }
        else if (this.misViewtype == 'labperformancereport') {
            this.getLabperformancereport(1);
        }
        else if (this.misViewtype == 'radiologytestcount') {
            this.getRadiologytestcount(1);
        }
        else if (this.misViewtype == 'servicedetails') {
            this.getServicebytariff(1);
        }
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/mis/mis.component.ts